import { DEFAULT_AMBIENT_OCCLUSION_CONFIG } from "./shared/ambient-occlusion-config"

// Co-authored-with: Claude
export function AmbientOcclusionHelp() {
  return (
    <div className="max-w-2xl mx-auto p-6 font-sans">
      <h1 className="text-xl font-bold mb-1">Ambient occlusion configuration</h1>
      <p className="text-sm mb-4">
        Only used when the selected postproduction style includes shadows (e.g. "Color + shadows").
        Consists of a GTAO pass (raw ambient occlusion) followed by a Poisson Denoise pass
        (smooths the result). All fields are optional; anything left unset falls back to the
        default value shown below.
      </p>

      <ul className="text-sm mb-4 list-disc pl-5 space-y-1">
        <li><b>gtao.radius</b> — sampling radius for occlusion, in scene units.</li>
        <li><b>gtao.distanceExponent</b> — falloff exponent for occlusion by distance.</li>
        <li><b>gtao.thickness</b> — assumed thickness of occluding surfaces.</li>
        <li><b>gtao.scale</b> — overall intensity of the AO effect.</li>
        <li><b>gtao.samples</b> — samples per pixel; higher looks smoother but costs more.</li>
        <li><b>gtao.distanceFallOff</b> — distance beyond which occlusion fades out.</li>
        <li><b>gtao.screenSpaceRadius</b> — radius in screen space (true) vs. world space (false).</li>
        <li><b>poissonDenoise.lumaPhi / depthPhi / normalPhi</b> — edge-preserving blur sensitivity
          to brightness, depth, and normal differences.</li>
        <li><b>poissonDenoise.radius / radiusExponent / rings / samples</b> — blur sampling
          pattern for the denoise pass.</li>
      </ul>

      <pre className="bg-slate-800 text-gray-200 rounded-lg p-4 text-xs overflow-x-auto font-mono leading-relaxed">
        {JSON.stringify(DEFAULT_AMBIENT_OCCLUSION_CONFIG, null, 4)}
      </pre>
    </div>
  )
}
